import React from 'react';
import Session from '../../utils/Session.js';
import { HomePageURL, Loading } from '../PageElements.js';


const Logout = () => {
    const url = HomePageURL();
    Session.clear();
    Session.setSecureValue('x-access-token', '');
    Session.setSecureValue('x-refresh-token', '');
    Session.setCookie('x-access-token', '');
    Session.setCookie('x-refresh-token', '');
    window.redirect(url);
    React.useEffect(() => {
        Session.clear();
        window.redirect(url);
        window.location.href = url;
    }, []);
    return <Loading />;
};

export default Logout;